import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'

// Check if analytics should be disabled
const analyticsDisabled = localStorage.getItem('analytics_off') === 'true';

if (!analyticsDisabled) {
  // Initialize Sentry before the React app starts
  initSentry();
}

createRoot(document.getElementById("root")!).render(<App />);
